const UserFieldsForGetContractWhere = [
	'id',
	'email',
	'userType',
	'stripeCustomerId',
];

export { UserFieldsForGetContractWhere };
